import _extends from "@babel/runtime/helpers/extends";
import { Box } from '@wix/design-system';
import { RecommendationLabel } from '@wix/ambassador-premium-domains-v1-recommendation/types';
import clsx from 'clsx';
import { WIX_HEADER_HEIGHT } from '@wix/core-domain-search';
import React from 'react';
import { useIsMobile } from '../../hooks/useIsMobile';
import { useIsScrolled } from '../../hooks/useIsScrolled';
import s from '../anonymousResultsPage.scss';
import transition from '../viewTransitions.css';
import { ResultsPageProvider, useResultsPageContext } from './ResultsPageContext';
const ResultsLayoutShell = _ref => {
  var _recommendations$;
  let {
    showCartHeader = false,
    stickyHeaderOffset = WIX_HEADER_HEIGHT,
    headerPadding,
    headerTop,
    searchBarFullWidth = false,
    searchBar,
    header,
    voucher,
    footer,
    mobileBackButton,
    children
  } = _ref;
  const isMobile = useIsMobile();
  const isScrolled = useIsScrolled();
  const {
    recommendations,
    error,
    isResultsPageOptimizations
  } = useResultsPageContext();
  const voucherOutsideStickyHeader = isResultsPageOptimizations && !isMobile;
  const removeSearchBarShadow = isResultsPageOptimizations && recommendations.length > 0 && ((_recommendations$ = recommendations[0]) == null ? void 0 : _recommendations$.label) !== RecommendationLabel.EXACT_MATCH;
  return /*#__PURE__*/React.createElement(Box, {
    display: "block",
    boxSizing: "border-box",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "grid",
    align: "center",
    className: clsx(s.resultsPage, s.noInsights, voucherOutsideStickyHeader && s.withVoucherRow),
    gap: isMobile ? 0 : 'SP4 0',
    height: "100%",
    backgroundColor: "white",
    overflow: "visible"
  }, voucherOutsideStickyHeader && /*#__PURE__*/React.createElement(Box, {
    gridArea: "voucher",
    boxSizing: "border-box",
    width: "100%",
    padding: "0 48px",
    marginBottom: "SP2"
  }, voucher), /*#__PURE__*/React.createElement(Box, _extends({
    boxSizing: "border-box",
    align: "center",
    gridArea: "header",
    top: headerTop ?? (isMobile ? undefined : '4px'),
    position: isMobile ? undefined : 'sticky',
    width: "100%",
    zIndex: 10,
    padding: headerPadding ?? (isMobile ? '0 SP4' : '0 48px SP2 48px'),
    margin: isMobile ? 'SP4 0 SP1' : undefined,
    backgroundColor: "white",
    direction: "vertical",
    gap: isMobile ? 'SP5' : 'SP6'
  }, showCartHeader && {
    paddingTop: 0,
    top: '56px' // height of the cart header
  }), isMobile && mobileBackButton, !voucherOutsideStickyHeader && voucher, header, !isMobile && /*#__PURE__*/React.createElement("div", {
    style: {
      ...(searchBarFullWidth && {
        width: '100%'
      }),
      zIndex: 11
    },
    className: clsx(transition.searchBar, isResultsPageOptimizations && s.optimizedSearchBar, removeSearchBarShadow && s.noSearchBarShadow)
  }, searchBar)), isMobile && /*#__PURE__*/React.createElement(Box, {
    top: stickyHeaderOffset,
    backgroundColor: isScrolled ? 'white' : 'transparent',
    className: s.mobileSearchBar
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx(transition.searchBar, removeSearchBarShadow && s.noSearchBarShadow)
  }, searchBar)), children, !error && recommendations.length > 0 && footer));
};
export const ResultsLayout = _ref2 => {
  let {
    biViewMode,
    reportGatePageLoadEvents,
    useReferralAdditionalInfoAsSearchOrigin,
    querySubmitPath,
    isResultsPageOptimizations,
    deviceType,
    productType,
    ...shellProps
  } = _ref2;
  return /*#__PURE__*/React.createElement(ResultsPageProvider, {
    biViewMode: biViewMode,
    reportGatePageLoadEvents: reportGatePageLoadEvents,
    useReferralAdditionalInfoAsSearchOrigin: useReferralAdditionalInfoAsSearchOrigin,
    querySubmitPath: querySubmitPath,
    isResultsPageOptimizations: isResultsPageOptimizations,
    deviceType: deviceType,
    productType: productType
  }, /*#__PURE__*/React.createElement(ResultsLayoutShell, shellProps));
};
//# sourceMappingURL=ResultsLayout.js.map